import  userMobx from "../mobx/user";
import { AllMessages } from "../types-project/Client";


export class SocketEvents {
    updateUser = () => {
        // store.dispatch(getUserInfos(undefined, true))
    }
    
    updateMessage =(data:string) => {
        userMobx.updateMsgBrandSocket(data)
    }

    getMessage = (data:AllMessages) => {       
        userMobx.getMsgBrandSocket(data)
    }

    // Nouvelle video validee recue dans un casting (event socket "media:new").
    getNewMedia = (data:any) => {
        userMobx.notifyNewMedia(data)
    }

    // Recharge la liste des conversations (utilise apres une reconnexion socket
    // pour ne pas perdre les messages arrives pendant la coupure).
    resyncMessages = () => {
        if ((userMobx.messages.data?.length ?? 0) > 0)
            userMobx.getAllMsgBrand()
    }
}